<template>
  <el-tabs v-model="tabs.activeName">
    <el-tab-pane :label="tab.label" :name="tab.name" v-for="(tab,i) in tabs.tabs" :key="'tabs'+i" lazy>
      <table-list :type="tab.type"></table-list>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { ElTabs, ElTabPane } from 'element-plus'
import TableList from './components/table-list.vue'
export default {
  components: {
    TableList, ElTabs, ElTabPane
  },
  setup () {
    const tabs = {
      activeName: 'businessCard',
      tabs: [
        { label: '名片介绍', name: 'businessCard', type: 1 },
        { label: '商品介绍', name: 'good', type: 2 },
        { label: '表单介绍', name: 'form', type: 3 },
        { label: '奖励介绍', name: 'reward', type: 4 }
      ]
    }

    return {
      tabs
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
